import * as validators from 'vuelidate/lib/validators';

const WHITESPACES = /\s/g;

const alphanumWithUnderscore = validators.helpers.regex('alphanumWithUnderscore', /^\w+$/);
const checkForWhiteSpace = checkedValue => {
  if (!checkedValue) return false;
  return checkedValue.match(WHITESPACES) === null;
};
const { required } = validators;
const { requiredIf } = validators;
const { not } = validators;

export { alphanumWithUnderscore, checkForWhiteSpace, required, requiredIf, not };
